import React, { createContext, useContext } from "react";

type SettingsPanelHostContextValue = {
  hosted: boolean;
};

const HOSTED_SETTINGS_PANEL_CONTEXT_VALUE: SettingsPanelHostContextValue = {
  hosted: true,
};

const SettingsPanelHostContext = createContext<SettingsPanelHostContextValue>({
  hosted: false,
});

export function SettingsPanelHostProvider(props: {
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <SettingsPanelHostContext.Provider value={HOSTED_SETTINGS_PANEL_CONTEXT_VALUE}>
      {props.children}
    </SettingsPanelHostContext.Provider>
  );
}

export function useSettingsPanelHosted(): boolean {
  return useContext(SettingsPanelHostContext).hosted;
}
